import { BackButton } from "./BackButton";
import { LanguageDropdown } from "@/components/i18n/LanguageDropdown";

/**
 * Compact universal top bar for secondary routes/modals.
 * Renders BackButton (left) + LanguageDropdown (right).
 * Mobile-first; sticks under the page header.
 */
export function RouteTopBar({
  fallback = "/",
  className = "",
}: {
  fallback?: string;
  className?: string;
}) {
  return (
    <div
      className={
        "sticky top-0 z-40 flex items-center justify-between gap-2 border-b border-border/50 bg-background/80 px-3 py-2 backdrop-blur " +
        className
      }
    >
      <BackButton fallback={fallback} />
      <LanguageDropdown />
    </div>
  );
}